import { render, staticRenderFns } from "./ExpenseRatesPage.vue?vue&type=template&id=09f51576"
import script from "./ExpenseRatesPage.vue?vue&type=script&lang=ts"
export * from "./ExpenseRatesPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports